const subsectionHeader = [
  {
    id: 1,
    title: 'Eventos',
    description:
      'Encontrarás talleres deportivos y culturales, conferencias y actividades.'
  },
  { id: 2, title: 'Refuerzo académico' },
  { id: 3, title: 'Recursos' }
];

export default {
  subsectionHeader
};
